import { Link } from "react-router-dom";
import { useBreadcrumb } from "@/contexts/BreadcrumbContext";
import { useEffect } from "react";

export function MetaDataDeletion() {
  const { clearBreadcrumbs } = useBreadcrumb();

  useEffect(() => {
    clearBreadcrumbs();
  }, []);

  return (
    <div className="container mx-auto p-8 max-w-3xl min-h-screen">
      <Link to="/" className="text-sm text-muted-foreground hover:text-foreground mb-8 inline-block">
        ← Back
      </Link>
      <h1 className="text-3xl font-bold mb-2">Data Deletion Request</h1>

      <div className="prose prose-slate dark:prose-invert max-w-none space-y-6">
        <p>
          To request deletion of your data, please email{" "}
          <a href="mailto:adam@xyzdigital.com">adam@xyzdigital.com</a> with your request.
        </p>
        <p>
          Include any relevant account information (e.g., email address, Facebook/Instagram
          account) to help us identify and process your request.
        </p>
      </div>
    </div>
  );
}
